import { Link, useLocation } from "react-router-dom";

export function MobileBottomNav() {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path: string) => {
    return currentPath === path;
  };

  // Kiểm tra xem có phải là các trang settings không
  const isSettingsPage = currentPath.startsWith("/settings");
  const isProfileEditPage = currentPath === "/profile/edit";
  const isEventsPage = currentPath === "/events";
  const isSavedPage =
    currentPath === "/saved" || currentPath === "/saved_product";
  const isMyGroupPage = currentPath === "/my_group";
  const bgColor =
    isSettingsPage ||
    isProfileEditPage ||
    isEventsPage ||
    isSavedPage ||
    isMyGroupPage
      ? "bg-[#FBF6F1]"
      : "bg-[#F4E7DA]";

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 w-full h-20 z-50 ${bgColor}`}
    >
      <div className="w-full h-12 mt-[23px] border-t-[0.05px] border-gray-300">
        {/* Hồ sơ */}
        <Link
          to="/profile"
          className="w-20 h-12 absolute right-0 inline-flex flex-col justify-end items-center gap-0.5"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5 20V19C5 15.134 8.13401 12 12 12C15.866 12 19 15.134 19 19V20"
              stroke="#6F6F6B"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z"
              stroke="#6F6F6B"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div
            className={`justify-start ${isActive("/profile") ? "text-[#8A8A86]" : "text-[#8A8A86]"} text-xs font-normal font-sora leading-none`}
          >
            Hồ sơ
          </div>
        </Link>

        {/* Mua bán */}
        <Link
          to="/marketplace"
          className="w-20 h-12 absolute right-[75px] inline-flex flex-col justify-end items-center gap-0.5"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M19.2609 9.69589L20.6455 18.6959C20.8319 19.9074 19.8945 21 18.6688 21H5.33124C4.10547 21 3.16811 19.9074 3.3545 18.6959L4.73911 9.69589C4.88922 8.72022 5.72872 8 6.71586 8H17.2842C18.2713 8 19.1108 8.72022 19.2609 9.69589Z"
              stroke="#6F6F6B"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5"
              stroke="#6F6F6B"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div
            className={`justify-start ${isActive("/marketplace") ? "text-[#8A8A86]" : "text-[#8A8A86]"} text-xs font-normal font-sora leading-none`}
          >
            Mua bán
          </div>
        </Link>

        {/* Tin nhắn */}
        <Link
          to="/chat"
          className="w-20 h-12 absolute left-[75px] inline-flex flex-col justify-end items-center gap-0.5"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.5 11.75C4.87665 11.75 2.75 13.8766 2.75 16.5C2.75 17.3664 2.98129 18.1766 3.38501 18.8745C3.47464 19.0294 3.5059 19.2113 3.47313 19.3873L3.21242 20.7876L4.61272 20.5269C4.7887 20.4941 4.9706 20.5254 5.12554 20.615C5.82344 21.0187 6.63357 21.25 7.5 21.25C10.1234 21.25 12.25 19.1234 12.25 16.5C12.25 13.8766 10.1234 11.75 7.5 11.75ZM1.25 16.5C1.25 13.0482 4.04822 10.25 7.5 10.25C10.9518 10.25 13.75 13.0482 13.75 16.5C13.75 19.9518 10.9518 22.75 7.5 22.75C6.46439 22.75 5.48585 22.4976 4.62441 22.0505L2.41228 22.4623C2.16923 22.5076 1.91949 22.4301 1.74467 22.2553C1.56985 22.0805 1.49242 21.8308 1.53767 21.5877L1.94953 19.3756C1.50244 18.5142 1.25 17.5356 1.25 16.5Z"
              fill="#8A8A86"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14 2.75C18.0041 2.75 21.25 5.99594 21.25 10C21.25 11.3218 20.897 12.5588 20.2805 13.6245C20.1909 13.7794 20.1596 13.9613 20.1924 14.1373L20.6626 16.6626L18.1373 16.1924C17.9613 16.1596 17.7794 16.1909 17.6245 16.2805C16.8777 16.7125 16.0472 17.0149 15.1631 17.1573C14.7542 17.2232 14.4761 17.6081 14.542 18.0171C14.6078 18.426 14.9928 18.7041 15.4017 18.6382C16.3735 18.4816 17.2918 18.1651 18.1285 17.7166L21.4627 18.3373C21.7058 18.3826 21.9555 18.3051 22.1303 18.1303C22.3051 17.9555 22.3826 17.7058 22.3373 17.4627L21.7166 14.1285C22.3761 12.8981 22.75 11.4917 22.75 10C22.75 5.16751 18.8325 1.25 14 1.25C9.59441 1.25 5.95042 4.50523 5.33988 8.74186C5.28079 9.15184 5.56525 9.53209 5.97523 9.59117C6.38521 9.65026 6.76546 9.3658 6.82454 8.95582C7.33023 5.44674 10.3508 2.75 14 2.75Z"
              fill="#8A8A86"
            />
          </svg>
          <div
            className={`justify-start ${isActive("/chat") ? "text-[#8A8A86]" : "text-[#8A8A86]"} text-xs font-normal font-sora leading-none`}
          >
            Tin nhắn
          </div>
        </Link>

        {/* Tin tức */}
        <Link
          to="/feed"
          className="w-20 h-12 absolute left-0 inline-flex flex-col justify-end items-center gap-0.5"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9 21.0005H7C4.79086 21.0005 3 19.2096 3 17.0005V10.7081C3 9.30932 3.73061 8.0122 4.92679 7.28724L9.92679 4.25694C11.2011 3.48466 12.7989 3.48466 14.0732 4.25694L19.0732 7.28724C20.2694 8.0122 21 9.30932 21 10.7081V17.0005C21 19.2096 19.2091 21.0005 17 21.0005H15M9 21.0005V17.0005C9 15.3436 10.3431 14.0005 12 14.0005C13.6569 14.0005 15 15.3436 15 17.0005V21.0005M9 21.0005H15"
              stroke="#8A8A86"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div
            className={`justify-start ${isActive("/feed") ? "text-[#8A8A86]" : "text-[#8A8A86]"} text-xs font-normal font-sora leading-none`}
          >
            Tin tức
          </div>
        </Link>
      </div>

      {/* Đăng bài */}
      <Link
        to="/create-post"
        className="w-20 h-16 absolute left-1/2 -ml-10 top-[1px] inline-flex flex-col justify-end items-center gap-1"
      >
        <div className="p-3 bg-[#E06448] rounded-full inline-flex justify-start items-center gap-2.5 absolute top-1">
          <div className="size-6 relative overflow-hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V11.25H18C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75H12.75V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V12.75H6C5.58579 12.75 5.25 12.4142 5.25 12C5.25 11.5858 5.58579 11.25 6 11.25H11.25V6C11.25 5.58579 11.5858 5.25 12 5.25Z"
                fill="#F4E7DA"
              />
            </svg>
          </div>
        </div>
        <div className="justify-start text-[#8A8A86] text-xs font-normal font-sora leading-none absolute -bottom-1.75">
          Đăng bài
        </div>
      </Link>
    </div>
  );
}
